import { network } from 'services/network';

export const exportFromOpcXerFile = (params) => {
    return network.post('api/bo/exportFromOpcXerFile', params).then((response) => response.data);
};
